import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/icons/landscape/bi-directional.svg'
import _imports_1 from '../../../../public/icons/landscape/Runtime.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-77171a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alm-wrapper" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "title-bar fs18" }
const _hoisted_4 = { class: "mb0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  ref: "almGrid",
  class: "main-alm-content"
}
const _hoisted_8 = { class: "content-title-bar" }
const _hoisted_9 = { class: "mb0 fs18" }
const _hoisted_10 = { class: "content-toolbar" }
const _hoisted_11 = { class: "toolbar-left-items" }
const _hoisted_12 = { class: "toolbar-right-items" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { id: "ag-paging-row-summary-panel" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icons-divider" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icons-divider" })
], -1))
const _hoisted_16 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon"
}, null, -1))
const _hoisted_18 = { class: "fs18" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_search_bar = _resolveComponent("f-search-bar")!
  const _component_f_icon_button = _resolveComponent("f-icon-button")!
  const _component_f_spin = _resolveComponent("f-spin")!
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!
  const _component_AlmRightSidebarInfo = _resolveComponent("AlmRightSidebarInfo")!
  const _component_calm = _resolveComponent("calm")!
  const _component_DeleteChangeset = _resolveComponent("DeleteChangeset")!
  const _component_AlmDeploymentModal = _resolveComponent("AlmDeploymentModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.localizer.Localize('ModuleSecurityDetailsView_LandscapeManagement')), 1),
          _createElementVNode("div", {
            class: "switch-tenant-btn",
            role: "button",
            tabindex: "0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchTenant && _ctx.switchTenant(...args)))
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_TenantSwitcher')), 1),
            _createVNode(_component_f_icon, {
              icon: "chevronright",
              size: 22,
              color: "primary"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_ChangeSets')), 1),
              _createVNode(_component_f_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCalm = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localizer.Localize('LandscapeManagement_CreateChangeSet')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("ul", _hoisted_11, [
                _createElementVNode("li", null, [
                  _createVNode(_component_f_search_bar, {
                    value: _ctx.findSearchValue,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.findSearchValue) = $event)),
                    activeIndex: _ctx.activeIndex,
                    count: _ctx.searchCount,
                    placeholder: _ctx.localizer.Localize('Find')
                  }, null, 8, ["value", "activeIndex", "count", "placeholder"])
                ])
              ]),
              _createElementVNode("ul", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("li", null, [
                  _createVNode(_component_f_icon_button, {
                    icon: "edit",
                    color: "dark",
                    title: _ctx.localizer.Localize('LandscapeManagement_Edit_Changeset'),
                    disabled: _ctx.selectedAlmChangesets?.length !== 1 || _ctx.selectedAlmChangesets?.[0]?.status === _ctx.STATUS.DEPLOYING,
                    onClick: _ctx.handleEdit
                  }, null, 8, ["title", "disabled", "onClick"])
                ]),
                _hoisted_15,
                _createElementVNode("li", null, [
                  _createVNode(_component_f_icon_button, {
                    icon: "delete",
                    color: "dark",
                    title: _ctx.localizer.Localize('LandscapeManagement_Delete_Changeset'),
                    disabled: _ctx.selectedAlmChangesets?.length !== 1 || _ctx.selectedAlmChangesets?.[0]?.status === _ctx.STATUS.DEPLOYING,
                    onClick: _ctx.handleDelete
                  }, null, 8, ["title", "disabled", "onClick"])
                ])
              ])
            ]),
            _createVNode(_component_f_spin, { spinning: _ctx.loadingChangesets }, null, 8, ["spinning"]),
            (!_ctx.changesets?.length && !_ctx.loadingChangesets)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_EmptyStateTitle')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_EmptyStateDescription')), 1),
                  _createVNode(_component_f_button, {
                    type: "primary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCalm = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.localizer.Localize('LandscapeManagement_CreateChangeSet')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.changesets?.length && !_ctx.loadingChangesets)
              ? (_openBlock(), _createBlock(_component_ag_grid_vue, {
                  key: 1,
                  "row-data": _ctx.rowData,
                  "column-defs": _ctx.colDefs,
                  class: "ag-theme-alpine landscape-ag-grid",
                  "suppress-cell-focus": "true",
                  "row-multi-select-with-click": true,
                  "row-selection": "multiple",
                  "row-height": 84,
                  pagination: true,
                  masterDetail: true,
                  detailCellRenderer: 'AlmRowDetailsRenderer',
                  detailCellRendererParams: (params) => {
                            return {
                                masterSelected: params?.data?.id === _ctx.selectedAlmChangesets?.[0]?.id && _ctx.selectedAlmChangesets?.length === 1
                            };
                        },
                  detailRowAutoHeight: true,
                  "suppress-context-menu": true,
                  "pagination-page-size": _ctx.rowsCountToFitContent,
                  "pagination-page-size-selector": _ctx.paginationPageSizeSelector,
                  "pagination-auto-page-size": true,
                  "row-class": "landscape-ag-grid-row",
                  onRowSelected: _ctx.onRowSelected,
                  onGridReady: _ctx.onGridReady
                }, null, 8, ["row-data", "column-defs", "detailCellRendererParams", "pagination-page-size", "pagination-page-size-selector", "onRowSelected", "onGridReady"]))
              : _createCommentVNode("", true)
          ], 512),
          (_ctx.selectedAlmChangesets?.length === 1)
            ? (_openBlock(), _createBlock(_component_AlmRightSidebarInfo, {
                key: 0,
                onClose: _ctx.onSidebarClose,
                onEdit: _ctx.handleEdit,
                onDeploy: _ctx.handleDeployment
              }, null, 8, ["onClose", "onEdit", "onDeploy"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showCalm)
      ? (_openBlock(), _createBlock(_component_calm, {
          key: 0,
          isVisible: _ctx.showCalm,
          isEditView: _ctx.isEditView,
          onClose: _ctx.closeCalm,
          currentChangeset: _ctx.actionableChangeset
        }, null, 8, ["isVisible", "isEditView", "onClose", "currentChangeset"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteChangeset)
      ? (_openBlock(), _createBlock(_component_DeleteChangeset, {
          key: 1,
          isVisible: _ctx.showDeleteChangeset,
          currentChangeset: _ctx.actionableChangeset,
          onClose: _ctx.closeDeleteModal
        }, null, 8, ["isVisible", "currentChangeset", "onClose"]))
      : _createCommentVNode("", true),
    (!!_ctx.changesetToDeploy)
      ? (_openBlock(), _createBlock(_component_AlmDeploymentModal, {
          key: 2,
          isVisible: !!_ctx.changesetToDeploy,
          currentChangeset: _ctx.changesetToDeploy,
          onClose: _cache[4] || (_cache[4] = ($event: any) => {_ctx.changesetToDeploy = null;}),
          onInitiateDeployment: _ctx.runDeployment
        }, null, 8, ["isVisible", "currentChangeset", "onInitiateDeployment"]))
      : _createCommentVNode("", true)
  ], 64))
}